/**
 * @constant {string} AFTER
 */
export const AFTER = 'after';

/**
 * @constant {string} AFTER_PRINT
 */
export const AFTER_PRINT = 'afterprint';

/**
 * @constant {string} BEFORE
 */
export const BEFORE = 'before';

/**
 * @constant {string} BEFORE_PRINT
 */
export const BEFORE_PRINT = 'beforeprint';

/**
 * @constant {Object} GLOBAL_VALUES
 */
export const GLOBAL_VALUES = {
  createNewEvent: null,
  hasMatchMediaSupport: false,
  hasNewErrorSupport: false,
  hasOnAfterPrintSupport: false,
  hasOnBeforePrintSupport: false,
  hasPrintEventSupport: false,
  isInitialized: false,
  mql: null,
};
